import type { ReactNode } from 'react'

import { Box, HStack } from '@enechain/ecloud-designsystem'

/**
 * CSV アップロード画面の 1 ステップ分の白地パネル (design `css/components.css` の
 * `.up-panel`: 白地・1px の淡い枠・角丸 lg・内側 16px)。 ステッパーとの間は 16px 空ける。
 * Step1 (ファイルの準備・選択) と Step2 (差分プレビュー) が同じ枠を使う。
 */
export const CsvUploadPanel = ({
  children,
}: {
  children: ReactNode
}): React.ReactElement => (
  <Box
    marginTop={4}
    padding={4}
    background="Surface.primary"
    borderWidth="1px"
    borderColor="Border.lowEmphasis"
    borderRadius="lg"
  >
    {children}
  </Box>
)

/**
 * パネル下端の操作行 (design `.up-actions`: 上に区切り線、 右にボタン)。
 * ボタンは design どおり M サイズで置く (`.up-actions-right .btn` = 40px)。
 * 上の要素との間 (design の margin-top 12px) は、 置き場所の縦並び (`CsvUploadStep1Panel`
 * の gap 12px) が持つ。 ここでも空けると 24px になる。
 */
export const CsvUploadPanelFooter = ({
  children,
}: {
  children: ReactNode
}): React.ReactElement => (
  <HStack
    justifyContent="flex-end"
    flexWrap="wrap"
    gap={2}
    paddingTop={3}
    borderTopWidth="1px"
    borderTopColor="Border.lowEmphasis"
  >
    {children}
  </HStack>
)
